import { Component, ChangeDetectionStrategy } from "@angular/core";
import { MatDialogActions, MatDialogClose, MatDialogContent } from "@angular/material/dialog";
import { MatButtonModule } from "@angular/material/button";
import { TranslatePipe } from "@tolgee/ngx";

@Component({
	selector: "app-legal-update-modal",
	imports: [MatDialogContent, MatDialogActions, MatButtonModule, MatDialogClose, TranslatePipe],
	templateUrl: "./legal-update-modal.component.html",
	changeDetection: ChangeDetectionStrategy.Eager,
	styleUrl: "./legal-update-modal.component.scss",
})
export class LegalUpdateModalComponent {}
